module.exports = __webpack_public_path__ + "img/H000170_crab.7371e676.png";